import React from 'react';
import { formatSEK, formatPercent, formatNumber } from './formatUtils';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

/**
 * KPIGrid — 2-4 metric cards with large numbers and optional trend indicators.
 * Financial-grade display: right context, color-coded by sentiment.
 */
export default function KPIGrid({ artifact }) {
  const { cards = [], period } = artifact;
  if (!cards.length) return null;

  return (
    <div className="finn-artifact finn-kpi-grid">
      {period && (
        <div className="finn-artifact-header">
          <span className="finn-artifact-period">{period}</span>
        </div>
      )}
      <div className="finn-kpi-cards" style={{ gridTemplateColumns: `repeat(${Math.min(cards.length, 4)}, 1fr)` }}>
        {cards.map((card, i) => {
          const formatted = card.format === 'currency'
            ? formatSEK(card.value)
            : card.format === 'percentage'
              ? formatPercent(card.value)
              : formatNumber(card.value);

          return (
            <div key={i} className="finn-kpi-card">
              <div className="finn-kpi-label">{card.label}</div>
              <div className="finn-kpi-value">{formatted}</div>
              {card.trend && (
                <div className={`finn-kpi-trend finn-kpi-trend-${card.trend.direction}`}>
                  {card.trend.direction === 'up' && <TrendingUp size={14} />}
                  {card.trend.direction === 'down' && <TrendingDown size={14} />}
                  {card.trend.direction === 'flat' && <Minus size={14} />}
                  <span>{card.trend.value != null ? formatPercent(card.trend.value) : ''}</span>
                  {card.trend.label && <span className="finn-kpi-trend-label">{card.trend.label}</span>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
